<template>
  <basic-container>
    <el-button @click="openDialog">新增</el-button>
    <el-table :data="tableData" border style="width: 100%;">
      <el-table-column fixed prop="id" label="id"> </el-table-column>
      <el-table-column prop="name" label="流程名"> </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
          <el-button type="text" size="small">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="新增流程" :visible.sync="dialogVisible" append-to-body>
      <avue-form :option="option"> </avue-form>
    </el-dialog>
  </basic-container>
</template>

<script>
export default {
  methods: {
    openDialog() {
      this.dialogVisible = !this.dialogVisible;
    },
    handleClick(row) {
      console.log(row);
    },
  },

  data() {
    return {
      tableData: [],
      dialogVisible: false,
      option: {
        labelWidth: 110,
        column: [
          {
            label: '流程点',
            prop: 'dynamic',
            type: 'dynamic',
            span: 24,
            children: {
              align: 'center',
              headerAlign: 'center',
              rowAdd: (done) => {
                this.$message.success('新增回调');
                done({
                  input: '默认值',
                });
              },
              rowDel: (row, done) => {
                this.$message.success('删除回调' + JSON.stringify(row));
                done();
              },
              column: [
                {
                  width: 200,
                  label: '处理人',
                  prop: 'handlePerson',
                  type: 'input',
                  disabled: true,
                },
                {
                  width: 200,
                  label: '选择框',
                  prop: 'select',
                  type: 'select',
                  rules: [
                    {
                      type: 'number',
                      require: true,
                      message: '请选择选择框',
                    },
                  ],
                  formatter: (row, value, label, column) => {
                    console.log(row, value, label, column);
                  },
                },
                {
                  width: 200,
                  label: '多选',
                  prop: 'checkbox',
                  type: 'checkbox',
                  dicData: [
                    {
                      label: '测试1',
                      value: 1,
                    },
                    {
                      label: '测试2',
                      value: 2,
                    },
                  ],
                },
                {
                  width: 200,
                  label: '开关',
                  prop: 'switch',
                  type: 'switch',
                  dicData: [
                    {
                      label: '测试1',
                      value: 1,
                    },
                    {
                      label: '测试2',
                      value: 2,
                    },
                  ],
                },
                {
                  width: 200,
                  label: '数字框',
                  prop: 'number',
                  type: 'number',
                },
              ],
            },
          },
        ],
      },
    };
  },
};
</script>

<style></style>
